import apiClient from '@u/apiClient'
import GetMetadataFromModelController from '@/wayfinder/actions/App/Http/Controllers/ModelNotification/GetMetadataFromModelController'
import FetchModelNotificationsByModelController from '@/wayfinder/actions/App/Http/Controllers/ModelNotification/FetchModelNotificationsByModelController'
import GetModelNotificationListController from '@/wayfinder/actions/App/Http/Controllers/ModelNotification/GetModelNotificationListController'
import CreateMultipleDraftFromDocument from '@/wayfinder/actions/App/Http/Controllers/ModelNotification/CreateMultipleDraftFromDocument'
import CreateModelNotificationController from '@/wayfinder/actions/App/Http/Controllers/ModelNotification/CreateModelNotificationController'
import CreateModelNotificationV2Controller from '@/wayfinder/actions/App/Http/Controllers/ModelNotification/CreateModelNotificationV2Controller'
import ReadModelNotificationController from '@/wayfinder/actions/App/Http/Controllers/ModelNotification/ReadModelNotificationController'
import GetThreadByGroupIdController from '@/wayfinder/actions/App/Http/Controllers/ModelNotification/GetThreadByGroupIdController'
import ShareAnswerModelNotificationController from '@/wayfinder/actions/App/Http/Controllers/ModelNotification/ShareAnswerModelNotificationController'
import GetModelNotificationByIdController from '@/wayfinder/actions/App/Http/Controllers/ModelNotification/GetModelNotificationByIdController'
import GetNewModelNotificationController from '@/wayfinder/actions/App/Http/Controllers/ModelNotification/GetNewModelNotificationController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
import GetMessageTextFromOpenAIController from '@/wayfinder/actions/App/Http/Controllers/OpenAI/GetMessageTextFromOpenAIController'
import UnTrashModelNotificationController from '@/wayfinder/actions/App/Http/Controllers/ModelNotification/UnTrashModelNotificationController'
import MoveToTrashModelNotificationController from '@/wayfinder/actions/App/Http/Controllers/ModelNotification/MoveToTrashModelNotificationController'
import MarkAsReadModelNotificationController from '@/wayfinder/actions/App/Http/Controllers/ModelNotification/MarkAsReadModelNotificationController'
import MarkAsUnReadModelNotificationController from '@/wayfinder/actions/App/Http/Controllers/ModelNotification/MarkAsUnReadModelNotificationController'
import MarkFavoriteModelNotificationController from '@/wayfinder/actions/App/Http/Controllers/ModelNotification/MarkFavoriteModelNotificationController'
import RestoreToInboxModelNotificationController from '@/wayfinder/actions/App/Http/Controllers/ModelNotification/RestoreToInboxModelNotificationController'
import ChangePublicStatusModelNotificationController from '@/wayfinder/actions/App/Http/Controllers/ModelNotification/ChangePublicStatusModelNotificationController'
import UpdateModelNotificationController from '@/wayfinder/actions/App/Http/Controllers/ModelNotification/UpdateModelNotificationController'
import UpdateModelNotificationV2Controller from '@/wayfinder/actions/App/Http/Controllers/ModelNotification/UpdateModelNotificationV2Controller'

let base_errors = { deceased: {}, events: [] }

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  // NEW (return promises)

  getMetadataFromModel(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetMetadataFromModelController.get(), {
          params: payload
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  /**
   * Mail history of a single model (invoice, dossier, supplier order).
   * Payload: { model_type, model_id }.
   */
  async fetchModelNotificationsByModel(_, payload) {
    return apiClient
      .route(FetchModelNotificationsByModelController.get(), {
        params: payload
      })
      .then((response) => response.data.model_notifications)
  },

  async fetchMessagesList({ state, commit }, { path, ...payload }) {
    if (state.abortController) {
      state.abortController.abort()
      state.abortController = null
    }

    state.abortController = new AbortController()

    return new Promise((resolve, reject) => {
      apiClient
        .route(GetModelNotificationListController.post({ path }), payload, {
          signal: state.abortController.signal
        })
        .then(async (response) => {
          commit('setMetadata', response.data.metadata)
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  async addDossierDocumentIntoMessage(_, payload) {
    return apiClient
      .route(CreateMultipleDraftFromDocument.post(), payload)
      .then((response) => response.data['model_notification'])
  },

  addOrUpdateModelNotification: ({ commit }, payload) => {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      let formData = new FormData()
      formData.append('data', JSON.stringify(payload))
      if (payload.new_attachments?.length > 0) {
        payload.new_attachments.forEach((file) =>
          formData.append('new_attachments[]', file, file.name)
        )
      }

      if (payload.id) {
        apiClient
          .formRoute(
            UpdateModelNotificationController.put({
              model_notification: payload.id
            }),
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((reason) => {
            reject(reason)
          })
      } else {
        apiClient
          .route(CreateModelNotificationController.post(), formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then((response) => {
            resolve(response.data)
          })
          .catch((reason) => {
            reject(reason)
          })
      }
    })
  },

  newAddOrUpdateModelNotification: ({ commit }, payload) => {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      let formData = new FormData()

      const { sendRecord, files, ...notification } = payload

      formData.append('data', JSON.stringify(notification))

      if (sendRecord) {
        formData.append('send_record', JSON.stringify(sendRecord))
      }

      if (files?.length > 0) {
        files.forEach((file) => {
          formData.append('files[]', file.file, file.file.name)
          formData.append(
            'files_properties[]',
            JSON.stringify(file.properties ?? null)
          )
        })
      }
      if (notification.id) {
        apiClient
          .formRoute(
            UpdateModelNotificationV2Controller.put({
              model_notification: notification.id
            }),
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((reason) => {
            reject(reason)
          })
      } else {
        apiClient
          .route(CreateModelNotificationV2Controller.post(), formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then((response) => {
            resolve(response.data)
          })
          .catch((reason) => {
            reject(reason)
          })
      }
    })
  },

  markAsReadModelNotification: ({ commit }, payload) => {
    commit('auth/setErrors', base_errors, { root: true })
    return apiClient
      .route(
        ReadModelNotificationController.put({
          modelNotification: payload.model_notification_id
        }),
        { read: payload.read }
      )
      .then((response) => response.data)
  },

  fetchThreadByGroupId({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetThreadByGroupIdController.get({ group_id: payload.groupId }))
        .then(async (response) => {
          commit('setMetadata', response.data.metadata)
          resolve(response)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  fetchThreadByGroupIdForAnswer(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ShareAnswerModelNotificationController.get({
            group_id: payload.groupId,
            type: payload.type
          })
        )
        .then(async (response) => {
          resolve(response?.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  fetchModelNotificationById: ({ commit }, payload) => {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetModelNotificationByIdController.get({
            model_notification: payload.id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchNewNewModelNotification: ({ commit }, payload) => {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewModelNotificationController.get(), {
          params: payload.params
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchNewModelNotification: ({ commit }, payload) => {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewModelController.get(), {
          params: {
            model: 'modelNotification',
            target_to: payload?.target_to
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchMessageOpenAI: (_, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetMessageTextFromOpenAIController.post(), payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  //endregion

  //region Action emails
  async storeNewEmail({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })

    let formData = new FormData()
    formData.append('data', JSON.stringify(payload.model_notification))

    if (payload.model_notification.attachments?.length > 0) {
      payload.model_notification.attachments.forEach((file) =>
        formData.append('attachments[]', file)
      )
    }

    await apiClient
      .route(CreateModelNotificationController.post(), formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((response) => {
        if (response.status === 200) {
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('storeNewEmail', reason)
      })
  },

  async updateModelNotification({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })

    let formData = new FormData()

    formData.append('data', JSON.stringify(payload.model_notification))

    if (payload.model_notification.attachments?.length > 0) {
      payload.model_notification.attachments.forEach((file) =>
        formData.append('attachments[]', file)
      )
    }

    formData.append('_method', 'PUT')

    await apiClient
      .post(`/api/model-notification-update/${payload.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(async (response) => {
        if (response.status === 201) {
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('error updateModelNotification', reason)
      })
  },

  async sendExistingEmail({ commit }, payload) {
    console.log(payload.email)
    commit('auth/setErrors', base_errors, { root: true })

    let formData = new FormData()
    formData.append('data', JSON.stringify(payload.email))
    if (payload.email.attachments?.length > 0) {
      payload.email.attachments.forEach((file) =>
        formData.append('attachments[]', file)
      )
    }
    console.log(formData)

    await apiClient
      .post(`/api/model-notification/${payload.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(async (response) => {
        await console.log('sendEmail', response)
        if (response.status === 202) {
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.log('sendEmail', reason)
      })
  },

  async unTrash({ commit }, payload) {
    return apiClient
      .route(UnTrashModelNotificationController.post(), payload)
      .then((response) => {
        if (response.data.metadata) {
          commit('setMetadata', response.data.metadata)
        }

        return response
      })
  },

  async moveToTrash({ commit }, payload) {
    return apiClient
      .route(MoveToTrashModelNotificationController.post(), payload)
      .then((response) => {
        if (response.data.metadata) {
          commit('setMetadata', response.data.metadata)
        }

        return response
      })
  },

  /**
   * Resolves to true when the API confirmed the update, false otherwise (errors are logged, not thrown).
   */
  async markAsReadEmails(_, payload) {
    return apiClient
      .route(MarkAsReadModelNotificationController.post(), payload)
      .then((response) => {
        if (response.status !== 200) {
          return false
        }
        processSuccessCallback(payload)
        return true
      })
      .catch((reason) => {
        console.error('markAsReadEmails', reason)
        return false
      })
  },

  async markAsUnReadEmails(_, payload) {
    await apiClient
      .route(MarkAsUnReadModelNotificationController.post(), payload)
      .then((response) => {
        if (response.status === 200) {
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('markAsUnReadEmails', reason)
      })
  },

  async markFavoriteEmails(_, payload) {
    await apiClient
      .route(MarkFavoriteModelNotificationController.post(), payload.models)
      .then((response) => {
        if (response.status === 200) {
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('markAsUnReadEmails', reason)
      })
  },

  async restoreEmail(_, payload) {
    await apiClient
      .route(RestoreToInboxModelNotificationController.post(), payload.models)
      .then((response) => {
        if (response.status === 200) {
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('restoreEmail', reason)
      })
  },

  async changePublicStatus(_, payload) {
    await apiClient
      .route(
        ChangePublicStatusModelNotificationController.post(),
        payload.models
      )
      .then((response) => {
        if (response.status === 200) {
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('changePublicStatus', reason)
      })
  }
  //endregion
}
